export const LeafMark = ({ className = "h-8 w-8", strokeWidth = 1.8 }) => (
  <svg viewBox="0 0 48 48" fill="none" className={className} aria-hidden="true">
    <g stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round">
      <path d="M24 6 C29.5 13.5 29.5 22 24 29 C18.5 22 18.5 13.5 24 6 Z" />
      <path d="M24 29 L24 40" />
      <path d="M11.5 13 C17.5 16.5 21 22 20.5 29 C13.5 27.5 9.5 20.5 11.5 13 Z" />
      <path d="M20.5 29 L15.5 37" />
      <path d="M36.5 13 C30.5 16.5 27 22 27.5 29 C34.5 27.5 38.5 20.5 36.5 13 Z" />
      <path d="M27.5 29 L32.5 37" />
    </g>
  </svg>
);
